import { render } from "./Scoreboard.vue?vue&type=template&id=eedac7c8&scoped=true"
import script from "./Scoreboard.vue?vue&type=script&lang=js"
export * from "./Scoreboard.vue?vue&type=script&lang=js"

import "./Scoreboard.vue?vue&type=style&index=0&id=eedac7c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eedac7c8"]])

export default __exports__